import axios from 'axios';

 //export const BASEURL= `https://proddispatch.allcityapp.com/actdispatcher/`
 //export const ADMIN_BASEURL="https://prodadminapi.allcityapp.com/actadmin/";
export const BASEURL="https://dispatcherapi.allcityapp.com/actdispatcher/"
export const ADMIN_BASEURL="https://devactadminapi2.allcityapp.com/actadmin/";
export default axios.create({
    baseURL: `${BASEURL}`
});